import type { RouteRecordRaw } from 'vue-router'
import { UserCircleIcon } from '@/components/icons'

export const ProfileRoutes: Array<RouteRecordRaw> = [
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/layouts/dashboard-layout/index.vue'),
    meta: { middleware: 'auth', requiresAuth: true },
    children: [
      {
        path: '',
        name: 'profile',
        component: () => import('@/views/profile/account/profile.vue'),
        meta: {
          title: 'پروفایل',
          breadcrumb: [{ text: 'پروفایل', to: '/profile', icon: UserCircleIcon }]
        }
      },
      {
        path: 'achievements',
        name: 'achievement-gallery',
        component: () => import('@/views/profile/achievements/index.vue'),
        meta: { requiresAuth: true, breadcrumb: [{ text: 'پروفایل', to: '/profile', icon: UserCircleIcon }, { text: 'دستاوردها' }] }
      },
      {
        path: 'edit',
        name: 'profile-edit',
        component: () => import('@/views/profile/account/profile-edit.vue'),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: 'ویرایش پروفایل' }
          ]
        }
      },
      {
        path: 'email-recovery',
        name: 'email_recovery',
        component: () =>
          import('@/views/profile/account/component/email-recovery/index.vue'),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: 'ویرایش پروفایل', to: { name: 'profile-edit' } },
            { text: ' ایمیل' }
          ]
        }
      },
      {
        path: 'mobile-recovery',
        name: 'mobile_recovery',
        component: () =>
          import(
            '@/views/profile/account/component/mobile-recovery/mobile-recovery.vue'
          ),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: 'ویرایش پروفایل', to: { name: 'profile-edit' } },
            { text: ' موبایل' }
          ]
        }
      },
      {
        path: 'search-users',
        name: 'search_users',
        component: () => import('@/views/profile/search-users/index.vue'),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: ' جستجو کاربران' }
          ]
        }
      },
      {
        path: 'user/:userId',
        name: 'other_user_profile',
        component: () => import('@/views/profile/other-user-profile/index.vue')
      },

      {
        path: 'direct-debit-transactions',
        name: 'direct-debit-transactions',
        component: () => import('@/views/profile/direct-debit-transactions.vue')
      },
      {
        path: 'set-goal',
        name: 'GoalSetting',
        component: () => import('@/views/profile/goal/index.vue'),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: 'هدف' }
          ]
        }
      },
      {
        path: 'day-streak',
        name: 'DayStreak',
        component: () => import('@/views/profile/day-streak/index.vue'),
        meta: {
          breadcrumb: [
            { text: 'پروفایل', to: '/profile', icon: UserCircleIcon },
            { text: 'زنجیره یادگیری' }
          ]
        }
      },
      {
        path: 'user-courses',
        name: 'userCourses',
        component: () => import('@/views/profile/user-courses/index.vue')
      }
    ]
  }
]
